import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Enum } from 'app/model/enum';
import { environment } from 'environments/environment';

@Injectable()
export class EnumService {
    
    private path = environment.url + 'api/v1/';

    constructor(private http: HttpClient) {}

    buscarGeneros(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/genero`);
    }

    buscarPaises(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/pais`);
    }

    buscarGrausEscolaridade(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/grau-instrucao`);
    }

    buscarRacaCor(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/raca-cor`);
    }

    buscarEstadoCivil(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/estado-civil`);
    }

    buscarPais(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/pais`);
    }

    buscarTipoLogradouro(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/tipo-logradouro`);
    }
    
    buscarMunicipio(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/municipio`);
    }

    buscarUF(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `uf`);
    }
    
    buscarCondicaoIngressoEstrangeiro(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/condicao-ingresso-estrangeiro`);
    }

    buscarCategoriaTrabalho(): Observable<Enum[]> {
        return this.http.get<Enum[]>(this.path + `enum/categoria-trabalho`);
    }
}